/**
 * 
 */
import * as mapvgl from 'mapvgl'
import AppMap from '@/components/AppMap.js'
import {
  geoRect
} from '@/common/MapTool.js'
import geoTowns from '@/components/geo-towns.js'
import {
  listEnterpriseOfTown
} from '@/api/enterprise.js'

function DetailMap() {
  var vue
  var lastZoom
  var zoomListener
  var labels
  /**
   * 显示某个乡镇，具体会展示乡镇内所有企业的种植面积
   * @param {*} v 
   * @param {*} code 
   */
  this.start = function (v, code) {
    vue = v
    const {
      map,
      view
    } = AppMap
    zoomListener = (e) => {
      const z = map.getZoom()
      if (labels && labels.length > 0) {
        if (lastZoom < 16.8 && z >= 16.8) {
          labels.forEach(lbl => {
            map.addOverlay(lbl)
          })
        } else if (lastZoom >= 16.8 && z < 16.8) {
          map.clearOverlays()
        }
      }
      lastZoom = z
    }
    const f = JSON.parse(JSON.stringify(geoTowns.features.find((current, index, arr) => {
      return current.properties.Code === code
    })))
    vue.setName(f.properties.Name)
    vue.setDesc(f.properties.Des)
    const loc = f.bbox
    const delta = Math.max(Math.abs(loc[0] - loc[2]), Math.abs(loc[1] - loc[3]))
    AppMap.fly2(
      (loc[0] + loc[2]) / 2,
      (loc[1] + loc[3]) / 2,
      delta < 0.18 ? 14 : 13.6
    ).then(() => {
      f.properties['height'] = 4000
      const shaperLayer = new mapvgl.ShapeLayer({
        color: 'rgb(105, 188, 255)', //rgb(0, 222, 255)
        style: 'gradual',
        riseTime: 900
      })
      view.addLayer(shaperLayer)
      shaperLayer.setData([f])

      listEnterpriseOfTown(code).then(enterprises => {
        const geo = {
          type: 'FeatureCollection',
          features: []
        }
        labels = []
        for (let i = 0; i < enterprises.length; i++) {
          const e = enterprises[i]
          // 绘制企业面积块
          let r = e.volumn < 5 ? 0.015 : e.volumn < 100 ? e.volumn * 0.003 : 0.3
          r = code === '112340121100000' ? e.volumn > 10 ? e.volumn * 0.0006 : e.volumn * 0.01 : r
          const f = geoRect(e.center, r, 16, 12, 2)
          f.id = i
          f.properties = {
            id: e.id,
            title: e.title,
            volumn: e.volumn,
            center: e.center
          }
          geo.features.push(f)
          //准备企业label（暂不显示，等到zoom到一定值时显示）
          const lbl = new BMapGL.Label(
            `
            <p class="enterprise-name">${e.title}</p>
            <p class="enterprise-volumn">${e.volumn} 亩</p>
            `, {
              position: new BMapGL.Point(e.center[0], e.center[1]),
              offset: new BMapGL.Size(10, -20)
            })
          lbl.setStyle({
            borderColor: 'rgba(0,0,0,0)',
            backgroundColor: 'rgba(0,0,0,0)',
          })
          labels.push(lbl)
        } //for

        const enterprisesLyr = new mapvgl.PolygonLayer({
          //cf1505
          fillColor: 'rgba(227, 21, 5, 0.9)', // 填充颜色
          lineWidth: 0,
          enablePicked: true, // 是否可以拾取
          selectedIndex: -1, // 选中项
          selectedColor: 'rgb(247, 21, 5)', // 选中项颜色
          autoSelect: true, // 根据鼠标位置来自动设置选中项
          onClick: (e) => {
            if (code === '112340121100000' && e && e.dataItem) {
              vue.$router.push({
                path: `/product/control/${code}/${e.dataItem.properties.id}`,
              })
              // console.log('town = ', code, 'e.dataItem = ', e.dataItem)
            }
          }
        })
        view.addLayer(enterprisesLyr)
        enterprisesLyr.setData(geo.features)

        lastZoom = map.getZoom()
        map.addEventListener('zoomend', zoomListener)
      }) // listEnterpriseOfTown()
    })
  }

  /**
   * 销毁之前绘制的所有内容，通常在页面切换时调用
   */
  this.destroy = function () {
    const {
      map,
      view
    } = AppMap
    view.removeAllLayers()
    map.clearOverlays()
    map.removeEventListener('zoomend', zoomListener)
  }

}

export default new DetailMap()



// WEBPACK FOOTER //
// ./src/components/industry/DetailMap.js